import { createTheme, ThemeProvider } from '@mui/material';
import { useThemeContext } from './ThemeContext';
import { ReactNode, useMemo } from 'react';
import AvailableThemes from '@/_constants/AvailableThemes';

interface MuiThemeProviderProps {
  children: ReactNode;
}

export function MuiThemeProvider({ children }: MuiThemeProviderProps) {
  const { activeTheme } = useThemeContext();
  const isDarkMode = activeTheme === AvailableThemes.DARK;

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: isDarkMode ? 'dark' : 'light',
          primary: {
            main: '#4E7DF6',
          },
          secondary: {
            main: '#F0851E', 
          },
        },
        typography: {
          fontFamily: '"Poppins", "Inter Variable", sans-serif',
          h1: {
            fontFamily: '"Poppins", sans-serif',
          },
          h2: {
            fontFamily: '"Poppins", sans-serif',
          },
          h3: {
            fontFamily: '"Poppins", sans-serif',
          },
          h4: {
            fontFamily: '"Poppins", sans-serif',
          },
          h5: {
            fontFamily: '"Poppins", sans-serif',
          },
          h6: {
            fontFamily: '"Poppins", sans-serif',
          },
        },
        components: {
          MuiTextField: {
            styleOverrides: {
              root: {
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'white',
                  borderRadius: '120px',
                  '& fieldset': {
                    borderColor: 'white',
                  },
                  '&:hover fieldset': {
                    borderColor: '#B2BAC2',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#E62B5A',
                  },
                  '& input': {
                    color: '#1A2027',
                  },
                  '& input::placeholder': {
                    color: '#4A5461', 
                    opacity: 1,
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#4A5461',
                },
              },
            },
          },
        },
      }),
    [isDarkMode]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
} 